module.exports = __webpack_public_path__ + "img/btn_google.95f1614d.png";